import { memo } from 'react';

import { Builder, withChildren } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { uiImages } from '@/react/components/content/registry/data';
import { toTitleCase } from '@/utils/string-utils';
import { SwappableComponentTrigger } from './index';

/**
 * Register the SwappableComponent component.
 */
const register = (): void => {
  const component = memo(
    dynamic(
      async () => import(/* webpackChunkName: "SwappableComponent" */ './index')
    )
  );
  const componentWithChildren = withChildren(component);

  Builder.registerComponent(componentWithChildren, {
    name: 'SwappableComponent',
    friendlyName: 'Swappable Component',
    canHaveChildren: true,
    inputs: [
      {
        name: 'triggers',
        friendlyName: 'Triggers',
        helperText:
          'The ways that the component can be triggered to swap content.',
        type: 'list',
        defaultValue: [],
        subFields: [
          {
            name: 'type',
            type: 'string',
            friendlyName: 'Trigger Type',
            enum: Object.values(SwappableComponentTrigger).map((value) => {
              return { label: toTitleCase(value), value };
            }),
            defaultValue: SwappableComponentTrigger.Click
          }
        ]
      }
    ],
    defaultChildren: [],
    image: uiImages.sectionImage
  });
};

export default register;
